import { render, staticRenderFns } from "./workRecordsTable.vue?vue&type=template&id=0b0b3db0&"
import script from "./workRecordsTable.vue?vue&type=script&lang=ts&"
export * from "./workRecordsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports